<script>
export default {
  props: {
    actual_plan_id: {
      type: Number
    },
    user: {},
    has_subscription: {}
  },
  data() {
    return {
      loadingGetPlans: true,
      plans: [],
    }
  },
  methods: {
    getPlans() {
      this.$http.get('/billing/plans/json').then(response => {
        this.plans = response.data.sort((a, b) => a.leads - b.leads);
      }).catch(error => {
        this.toast.error('Ops! Houve um erro ao buscar os planos.')
      }).finally(() => {
        this.loadingGetPlans = false;
      });
    }
  },
  computed: {
    enterpriseLeads() {
      return this.plans[this.plans.length - 1]?.leads;
    },
    username() {
      return window.BulldeskSettings.name;
    },
    pageTexts() {
      let messages = {
        title: this.__("Minha Assinatura"),
        subtitle: this.__('selecione um plano para continuar'),
      }

      if (!this.has_subscription) {
        messages.title = this.__("Pagamento");
        messages.subtitle = this.__("selecione o plano que mais combina com o seu negócio.");
      }

      return messages;
    }
  },
  mounted() {
    this.getPlans();
  }
}
</script>

<template>
  <div>
    <template v-if="loadingGetPlans">
      <div class="w-100 mt-72px d-flex align-items-center justify-content-center">
        <i class="fa fa-circle-o-notch fa-spin" />
      </div>
    </template>
    <template v-else>
      <div class="row bdk-pl-8 bdk-pr-8">
        <div class="col-12 p-0">
          <h1 class="page-title">
            {{ pageTexts.title }}
          </h1>
        </div>
      </div>
      <div class="row bdk-pl-8 bdk-pr-8">
        <div class="col-12 p-0 d-flex align-items-center justify-content-between">
          <h2 class="page-subtitle">
            <b>{{ __('Olá') }} {{ user.name }}</b>, {{ pageTexts.subtitle }}
          </h2>
        </div>
      </div>
      <div class="row plans-row p-3 justify-content-center">
        <billing-plan v-for="plan in this.plans" :key="plan.i" :name="plan.name" :price="plan.price" :leads="plan.leads"
          :users="plan.max_users" :clickUrl="`/checkout?plan=${plan.id}`" :is_actual_plan="plan.id == actual_plan_id" />
        <!-- plano enterprise virtual -->
        <billing-plan name="Salesflow Custom" :leads="enterpriseLeads" :price="0" :is_actual_plan="false" :users="0"
          :is_enterprise_plan="true"
          :clickUrl="'https://chat.movidesk.com/ChatWidgetNewNew/Landing/9A851CD5A441419FA680C62374E1F73D'" />
      </div>
    </template>
  </div>

</template>

<style scoped>
.plans-row {
  gap: 24px;
}
</style>
